<template>
	<div>
		<user-nav-menu
			user-type="LOCUM"
			bg-color="transparent"
			text-color="#ffffff"
			:disable-edit-profile="true"
			:logo-file-name="tenant.settings.brandImages.headerLogos.app.light"
		></user-nav-menu>
		<v-row align="center" justify="center" class="mb-5">
			<v-col cols="11" md="7" sm="7">
				<v-overlay :value="spinning"><v-progress-circular :indeterminate="true"></v-progress-circular></v-overlay>
				<h1 class="create-profile-title justify-center text-center pb-5 pt-5">Edit Profile</h1>
				<notification v-show="showNotification"></notification>

				<v-card class="card-rounded elevation-1 mt-3 pt-3" style="width: 100%; height: auto">
					<v-card-title class="pb-0 pl-0">
						<v-btn
							v-show="context != 'complete-profile-steps' && context != previous_context && previous_context != null"
							class="mt-5"
							text
							x-large
							fab
							absolute
							left
							top
							color="secondary"
							style="font-family: Montserrat; font-style: normal; font-weight: bold; font-size: 18px; line-height: 17px"
							@click="goBack"
							><v-icon left color="secondary">mdi-chevron-left</v-icon>Back</v-btn
						>
					</v-card-title>

					<v-container v-show="context === 'complete-profile-steps'" align="center" justify="center" class="pa-5 pb-0">
						<v-list-item three-line>
							<v-list-item-content>
								<v-list-item-title class="text-center text-wrap">Begin editing your profile by selecting a section below.</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-container>
					<component :is="context ? context : 'v-card'" :required_forms="required_forms" :booster_forms="booster_forms" :button-colours="buttonColours"></component>

					<v-card-actions align="center" justify="center" class="justify-center text-center">
						<v-container>
							<v-row align="center" justify="center">
								<v-col cols="12" sm="12" md="12">
									<v-btn
										v-show="show_button"
										:loading="spinning"
										large
										class="text-none button-rounded continue-signup-button"
										:height="54"
										color="primary"
										@click="SubmitForm()"
										>Save changes<v-icon>mdi-chevron-right</v-icon></v-btn
									>
								</v-col>
							</v-row>
							<v-row v-show="context != 'complete-profile-steps'">
								<v-col cols="12" sm="12" md="12">
									<v-btn
										class="pt-0 mt-0"
										text
										link
										color="primary"
										style="
											font-family: Montserrat;
											font-style: normal;
											font-weight: normal;
											font-size: 14px;
											line-height: 18px;
											text-align: right;
											text-decoration-line: none;
										"
										@click="returnToOverview"
									>
										Return to Profile Overview
									</v-btn>
								</v-col>
							</v-row>
							<v-row>
								<v-col class="ma-0 pa-0" cols="12" sm="12" md="12">
									<v-btn
										class="pt-0 mt-0"
										text
										link
										color="primary"
										style="
											font-family: Montserrat;
											font-style: normal;
											font-weight: normal;
											font-size: 14px;
											line-height: 18px;
											text-align: right;
											text-decoration-line: none;
										"
										@click="openLocumPreview"
									>
										Preview how your profile is seen
									</v-btn>
								</v-col>
							</v-row>
							<v-row class="mt-3">
								<v-col class="ma-0 pa-0" cols="12" sm="12" md="12">
									<v-btn
										class="pt-0 mt-0"
										text
										link
										color="primary"
										style="
											font-family: Montserrat;
											font-style: normal;
											font-weight: bold;
											font-size: 16px;
											line-height: 20px;
											text-align: right;
											text-decoration-line: none;
										"
										@click="returnToDashboard"
									>
										Return to dashboard
									</v-btn>
								</v-col>
							</v-row>
						</v-container>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { bus } from '@/main';
// import { Auth } from 'aws-amplify'
// import axios from 'axios';
import store from '@/store';

import CompleteProfileSteps from '@/components/locum/profile/EditProfileStepsForm.vue';
import notification from '@/components/locum/complete profile steps/notification.vue';

import educationStep from '@/components/locum/complete profile steps/Education.vue';
import bankingStep from '@/components/locum/complete profile steps/PaymentDetails.vue';
import uploadIdStep from '@/components/locum/complete profile steps/UploadID.vue';
import ratesStep from '@/components/locum/complete profile steps/Rates.vue';
import experienceStep from '@/components/locum/complete profile steps/Experience.vue';
import locationsStep from '@/components/locum/complete profile steps/Locations.vue';
import AboutStep from '../components/locum/complete profile steps/About.vue';
import UserNavMenu from '@/components/user/UserNavMenu';

import { Tracking } from '@/utils';

export default {
	components: {
		CompleteProfileSteps,
		notification,
		UserNavMenu,
		educationStep,
		bankingStep,
		uploadIdStep,
		ratesStep,
		experienceStep,
		locationsStep,
		AboutStep,
	},
	data: () => ({
		topcard: 'progressbar',
		showNotification: false,
		// button_text : "None",
		// button_color : "primary",
		button_state: false,
		spinning: false,
		button_loading: false,
		previous_context: null,
	}),
	computed: {
		user: () => store.getters.user,
		required_forms: () => store.getters.stepsRequired.filter(step => step.context != 'create-account-step'),
		booster_forms: () => store.getters.stepsBoosted,
		context: () => store.getters.currentStep,
		show_button: function () {
			return this.context != 'complete-profile-steps';
		},
		buttonColours: () => store.getters.getProfileButtonColours,
	},

	created() {},

	async mounted() {
		Tracking.track('Locum_Edit_Profile', {});
		bus.$on('intent:previous-context', () => {
			store.commit('SET_STEP', this.previous_context);
			bus.$emit('steps@refresh');
		});
		bus.$on('intent:change-context', new_context => {
			this.previous_context = this.context;
			store.commit('SET_STEP', new_context); //get the state and commit.
			bus.$emit('steps@refresh');
		});

		bus.$on('intent:next-step', () => {
			bus.$emit('intent:change-context', 'complete-profile-steps');
			bus.$emit('push:notification@update', {
				title: 'Profile Updated',
				subtitle: 'Your profile was updated successfully.',
				avatar: false,
			});
			bus.$emit('push:notification@show');
		});

		bus.$on('push:notification@hide', () => {
			this.showNotification = false;
		});

		bus.$on('push:notification@show', () => {
			this.showNotification = true;
		});

		bus.$on('update:spinning', value => {
			this.spinning = value;
		});
	},

	beforeDestroy() {
		bus.$off('intent:previous-context');
		bus.$off('intent:change-context');

		bus.$off('update:spinning');

		bus.$off('update:topcard');

		bus.$off('push:notification@hide');

		bus.$off('push:notification@show');

		bus.$off('steps@refresh');

		bus.$off('intent:next-step');

		bus.$off('update:next-button-text');

		bus.$off('update:next-button-color');

		bus.$off('update:next-button-enable');
	},

	methods: {
		goBack() {
			bus.$emit('intent:previous-context');
		},
		openLocumPreview() {
			bus.$emit('show-locum-preview-popup');
		},
		returnToDashboard() {
			this.spinning = true;
			bus.$emit('intent:change-context', 'complete-profile-steps');
			this.$router.push('/').catch(() => {});
		},
		returnToOverview() {
			bus.$emit('intent:change-context', 'complete-profile-steps');
		},
		SubmitForm() {
			bus.$emit('intent:submit-forms'); //submit the form, the form is expected to fire the 'next-step' intent when done.
		},
	},
};
</script>
